import axios from 'axios';
import { API, authHeaders } from './client';

export const getTemplates = (token) =>
  axios.get(`${API}/templates`, authHeaders(token)).then(r => r.data);

export const createTemplate = (token, data) =>
  axios.post(`${API}/templates`, data, authHeaders(token)).then(r => r.data);

export const updateTemplate = (token, id, data) =>
  axios.put(`${API}/templates/${id}`, data, authHeaders(token)).then(r => r.data);

export const deleteTemplate = (token, id) =>
  axios.delete(`${API}/templates/${id}`, authHeaders(token)).then(r => r.data);

export const toggleTemplate = (token, id) =>
  axios.put(`${API}/templates/${id}/toggle`, {}, authHeaders(token)).then(r => r.data);
